import { ApplicationModule, NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';
import { SharedModule } from '@dash/randy/shared/shared.module';
import { LoginComponent } from './components/login/login.component';
import { authInterceptorProviders } from './helpers/auth.interceptor';
import { RouterModule } from '@angular/router';
import { LogoutComponent } from './components/logout/LogoutComponent';
import { LocalePipe } from './helpers/locale.pipe';
import { LogService } from '@dash/randy/shared/classes/log.service';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { CallbackComponent } from './components/callback/callback.component';
import { environment } from '../../../environments/environment';
import { CognitoService } from '@dash/randy/security/service/cognito.service';
import { RoleService } from '@dash/randy/security/service/role.service';
import { RoleSelectionComponent } from './components/role-selection/role-selection.component';
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import { NgOptimizedImage } from '@angular/common';

// We need a factory, since localStorage is not available during AOT build time.
export const storageFactory = (): OAuthStorage => localStorage;

@NgModule({
  declarations: [LoginComponent, LogoutComponent, LocalePipe, CallbackComponent, RoleSelectionComponent],
  imports: [
    SharedModule,
    RouterModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: environment.aws.allowedApiUrls,
        sendAccessToken: true,
      },
    }),
    ApplicationModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggle,
    NgOptimizedImage,
  ],
  exports: [LoginComponent, LogoutComponent, LocalePipe, RoleSelectionComponent],
  providers: [LocalePipe, { provide: OAuthStorage, useFactory: storageFactory }],
})
export class SecurityModule {
  constructor(private logService: LogService, @Optional() @SkipSelf() parentModule?: SecurityModule) {
    logService.debug('Security INITIALIZER');
    if (parentModule) {
      // throw new Error('GreetingModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): any {
    return {
      ngModule: SecurityModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = ((service: CognitoService) => async () => {
            const res = await service.init();
            console.log('CognitoService initialized', res);
            return res;
          })(inject(CognitoService));
          return initializerFn();
        }),
        provideAppInitializer(() => {
          const initializerFn = (
            (service: RoleService) => () =>
              service.init()
          )(inject(RoleService));
          return initializerFn();
        }),
        authInterceptorProviders,
      ],
    };
  }
}
